import { mapMutations }   from "vuex";
import Tls                from "@/services/Tls";
import GroupMap           from "@/components/Group/Map";
import GroupInstructions  from "@/components/Group/Instructions";
import MessagesList       from "@/components/TlsCase/Messages/List";
import NewServiceTlsCase  from "@/components/ServiceTls/NewCase";

// ==================
// NAME
// ==================
const name = "TlsCaseShow";

// ==================
// DATA
// ==================
const newMessage = {
	body: null, private: true
};

const data = function () {
	return {
		loading:         false,
		ownerId:         null,
		colleagues:      [],
		instructions:    [],
		messages:        [],
		group:           {},
		tlsCase:         {},
		newMessage:      { ...newMessage },
		token: this.$store.state.token
	};
};

// ==================
// METHODS
// ==================
const toastMessage = function (message) {
	this.$toasted.show(message, {
		position: "bottom-center",
		duration: 3000,
		action: {
			text: "Fermer",
			onClick: (e, toastObject) => {
				toastObject.goAway(0);
			}
		}
	});
};

const fetchData = function () {
	const { groupId, caseId } = this.$route.params;
  
	Tls.Groups.find(groupId).then(response => {
		this.group = response.group;
	});
  
	Tls.Cases.find({ groupId, caseId }).then(response => {
		if (response.case) {
			this.tlsCase = response.case;
      
			this.addTlsCase(this.tlsCase);

			if (this.tlsCase.owner) {
				this.ownerId = this.tlsCase.owner.id;
			}
		}
	});
  
	Tls.Pros.all().then(response => {
		this.colleagues = response.pros;
	});
};

const submitMessageForm = function (e) {
	e.preventDefault();
  
	if (this.newMessage.body) {
		const { groupId, caseId } = this.$route.params;
    
		Tls.Messages.create({ groupId, caseId, message: this.newMessage }).then(_ => {
			this.newMessage = { ...newMessage };
      
			toastMessage.bind(this)("Message envoyé !");

			this.$refs.messagesList.refresh();
		}).catch(error => {
			toastMessage.bind(this)(error.message);
		});
	} else {
		toastMessage.bind(this)("Message doit être rempli !");
	}
};

const assignTlCase = function (e) {
	e.preventDefault();

	const { caseId } = this.$route.params;

	if (this.ownerId) {
		Tls.Cases.assign(caseId, this.ownerId).then(_ => {
			toastMessage.bind(this)("Ticket assigné !");

			this.$refs.messagesList.refresh();
		});
	}
};

const openTransferModal = function (event) {	
	event.preventDefault();

	const { $refs: { serviceTlsNewCase } } = this;

	if (serviceTlsNewCase) {
		const { $refs: { modal } } = serviceTlsNewCase;
		modal.openModal();
	}
};

const closeCase = function (event) {
	event.preventDefault();

	const { id: caseId, group_id: groupId } = this.tlsCase;

	Tls.Cases.close({ caseId, groupId })
		.then(_ => {
			this.tlsCase["status"] = "resolved";
			toastMessage.bind(this)("Le ticket a bien été clôturé !"); 
		})
		.catch(error => {
			return Promise.reject(error);
		});
};


// ==================
// COMPONENT
// ==================
export default {
	name,
	data,
	components: {
		GroupMap,
		GroupInstructions,
		MessagesList,
		NewServiceTlsCase
	},
	methods: {
		...mapMutations(["addTlsCase"]),
		fetchData,
		assignTlCase,
		submitMessageForm,
		openTransferModal,
		closeCase
	},
	computed:  {
		pendingCase: function() {
			return this.tlsCase && this.tlsCase.status == "pending";
		},
		isAdmin: function () {
			return this.$store.getters.isAdmin;
		}
	},
	mounted() {
		this.fetchData();
		document.body.classList.add("CaseShow");
	},
	watch: {
		"$route": "fetchData"
	},
	destroyed() {
		document.body.classList.remove("CaseShow");
	}
};
